import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { EditHolidayIprops } from '../types'
import { holidaySchema } from '../../schema'
import { editHoliday } from '../../slice/holidayslice'
import { useAppDispatch } from '../../../../redux/hook'
import { convertDateFormat } from '../../utils'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'

interface HolidayFormValues {
    title: string
    holidayDate: string
}

const EditHoliday = ({ show, onClose, data }: EditHolidayIprops) => {
    const dispatch = useAppDispatch()

    const getDayName = (date: Date): string => {
        const days = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
        ]
        return days[date.getDay()]
    }

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Edit Holiday"
            body={
                <Formik
                    initialValues={{
                        title: data.title,
                        holidayDate: convertDateFormat(data.holidayDate),
                    }}
                    validationSchema={holidaySchema}
                    onSubmit={(
                        values,
                        actions: FormikHelpers<HolidayFormValues>
                    ) => {
                        dispatch(SHOW_LOADER())
                        const payload = {
                            holidayName: values.title,
                            holidayDate: new Date(values.holidayDate),
                            comment: values.title,
                            id: data.id,
                            title: values.title,
                            holidayDay: getDayName(
                                new Date(values.holidayDate)
                            ),
                        }

                        dispatch(editHoliday(payload))
                            .then(() => {
                                actions.setSubmitting(false)
                                onClose(false)
                                dispatch(HIDE_LOADER())
                            })
                            .catch((error) => {
                                console.error('Error editing holiday:', error)
                                actions.setSubmitting(false)
                                dispatch(HIDE_LOADER())
                            })
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <InputField
                                type="text"
                                name="title"
                                lable="Holiday name"
                                value={values.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.title}
                                touched={touched.title}
                            />
                            <InputField
                                type="date"
                                name="holidayDate"
                                lable="Date"
                                value={values.holidayDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.holidayDate}
                                touched={touched.holidayDate}
                            />
                            <div className="footer-block">
                                <Button type="submit" disabled={isSubmitting}>
                                    Edit
                                </Button>
                                <Button
                                    type="button"
                                    disabled={isSubmitting}
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}

export default EditHoliday
